export default {
  dialetos: null,
  flMostraPerpetua: null,
  flMostraCodigoSepultamento: null,
  flEmImplantacao: null,
  menus: null
};
